import { render, staticRenderFns } from "./bosPaginator.vue?vue&type=template&id=7ce25a5c&"
import script from "./bosPaginator.vue?vue&type=script&lang=js&"
export * from "./bosPaginator.vue?vue&type=script&lang=js&"
import style0 from "./bosPaginator.vue?vue&type=style&index=0&id=7ce25a5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports